define(['morningstar', './config.js', './instance-registry.js',
    './util.js'], function(morningstar, config, instanceRegistry, util) {
    'use strict';
    var _bootstrapCallbacks = [];
    var _hasInited = false;

    reset();

    return {
        init: init,
        reset: reset,
        registerCallback: registerCallback
    };

    function init(options) {
        if (_hasInited && window && !window.__karma__ && !window.__testing__) {
            if (window.console) {
                window.console.warn('Tried to call asterix.bootstrap.init multiple times');
            }

            return;
        }

        _hasInited = true;
        options = options || {};
        var appConfig = options.appConfig;
        delete options.appConfig;
        options = util.merge({}, {
            appName: 'morningstarApp',
            appConfig: null,
            baseLabels: {},
            baseSettings: {},
            configOptions: {
                dynamic: false
            }
        }, options || {});

        options.appConfig = appConfig;
        options.defaultConfig = morningstar.components._defaultConfig || {};

        // todo(slind): we could merge options.appConfig with morningstar.components._appConfig, but not sure if that's behaviour that we want

        if (!options.appConfig || !options.appConfig.components ||
            Object.keys(options.appConfig.components).length === 0) {
            options.configOptions.dynamic = true;
        }

        util.each(_bootstrapCallbacks, function(cb) {
            cb(options);
        });
    }

    function registerCallback(cb) {
        _bootstrapCallbacks.push(cb);
    }

    function reset() {
        _bootstrapCallbacks = [];
        _bootstrapCallbacks.push(function defaultCb(options) {
            config.init(options.appConfig ||
                morningstar.components._appConfig ||
                {components: {}}, options.defaultConfig, options.baseLabels, options.baseSettings, options.configOptions);
            instanceRegistry.init();
        });
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./components/core/src/js/bootstrap.js
 ** module id = 116
 ** module chunks = 0
 **/